/**
 * 英語で指定された都道府県名を、日本語の正式名称または略称に変換する
 * 都道府県名の末尾に「都道府県」を含めるかどうか選択可能
 *
 * @param prefecture - 英語での都道府県名
 * @param locale - ローカライゼーション
 * @param includeSuffix - trueの場合、都道府県名の末尾に「都道府県」を含める
 */

export const prefectureMap: {
  [key: string]: { ja: { withSuffix: string; withoutSuffix: string }; en: string };
} = {
  Hokkaido: { ja: { withSuffix: '北海道', withoutSuffix: '北海道' }, en: 'Hokkaido' },
  Aomori: { ja: { withSuffix: '青森県', withoutSuffix: '青森' }, en: 'Aomori' },
  Iwate: { ja: { withSuffix: '岩手県', withoutSuffix: '岩手' }, en: 'Iwate' },
  Miyagi: { ja: { withSuffix: '宮城県', withoutSuffix: '宮城' }, en: 'Miyagi' },
  Akita: { ja: { withSuffix: '秋田県', withoutSuffix: '秋田' }, en: 'Akita' },
  Yamagata: { ja: { withSuffix: '山形県', withoutSuffix: '山形' }, en: 'Yamagata' },
  Fukushima: { ja: { withSuffix: '福島県', withoutSuffix: '福島' }, en: 'Fukushima' },
  Ibaraki: { ja: { withSuffix: '茨城県', withoutSuffix: '茨城' }, en: 'Ibaraki' },
  Tochigi: { ja: { withSuffix: '栃木県', withoutSuffix: '栃木' }, en: 'Tochigi' },
  Gunma: { ja: { withSuffix: '群馬県', withoutSuffix: '群馬' }, en: 'Gunma' },
  Saitama: { ja: { withSuffix: '埼玉県', withoutSuffix: '埼玉' }, en: 'Saitama' },
  Chiba: { ja: { withSuffix: '千葉県', withoutSuffix: '千葉' }, en: 'Chiba' },
  Tokyo: { ja: { withSuffix: '東京都', withoutSuffix: '東京' }, en: 'Tokyo' },
  Kanagawa: { ja: { withSuffix: '神奈川県', withoutSuffix: '神奈川' }, en: 'Kanagawa' },
  Niigata: { ja: { withSuffix: '新潟県', withoutSuffix: '新潟' }, en: 'Niigata' },
  Toyama: { ja: { withSuffix: '富山県', withoutSuffix: '富山' }, en: 'Toyama' },
  Ishikawa: { ja: { withSuffix: '石川県', withoutSuffix: '石川' }, en: 'Ishikawa' },
  Fukui: { ja: { withSuffix: '福井県', withoutSuffix: '福井' }, en: 'Fukui' },
  Yamanashi: { ja: { withSuffix: '山梨県', withoutSuffix: '山梨' }, en: 'Yamanashi' },
  Nagano: { ja: { withSuffix: '長野県', withoutSuffix: '長野' }, en: 'Nagano' },
  Gifu: { ja: { withSuffix: '岐阜県', withoutSuffix: '岐阜' }, en: 'Gifu' },
  Shizuoka: { ja: { withSuffix: '静岡県', withoutSuffix: '静岡' }, en: 'Shizuoka' },
  Aichi: { ja: { withSuffix: '愛知県', withoutSuffix: '愛知' }, en: 'Aichi' },
  Mie: { ja: { withSuffix: '三重県', withoutSuffix: '三重' }, en: 'Mie' },
  Shiga: { ja: { withSuffix: '滋賀県', withoutSuffix: '滋賀' }, en: 'Shiga' },
  Kyoto: { ja: { withSuffix: '京都府', withoutSuffix: '京都' }, en: 'Kyoto' },
  Osaka: { ja: { withSuffix: '大阪府', withoutSuffix: '大阪' }, en: 'Osaka' },
  Hyogo: { ja: { withSuffix: '兵庫県', withoutSuffix: '兵庫' }, en: 'Hyogo' },
  Nara: { ja: { withSuffix: '奈良県', withoutSuffix: '奈良' }, en: 'Nara' },
  Wakayama: { ja: { withSuffix: '和歌山県', withoutSuffix: '和歌山' }, en: 'Wakayama' },
  Tottori: { ja: { withSuffix: '鳥取県', withoutSuffix: '鳥取' }, en: 'Tottori' },
  Shimane: { ja: { withSuffix: '島根県', withoutSuffix: '島根' }, en: 'Shimane' },
  Okayama: { ja: { withSuffix: '岡山県', withoutSuffix: '岡山' }, en: 'Okayama' },
  Hiroshima: { ja: { withSuffix: '広島県', withoutSuffix: '広島' }, en: 'Hiroshima' },
  Yamaguchi: { ja: { withSuffix: '山口県', withoutSuffix: '山口' }, en: 'Yamaguchi' },
  Tokushima: { ja: { withSuffix: '徳島県', withoutSuffix: '徳島' }, en: 'Tokushima' },
  Kagawa: { ja: { withSuffix: '香川県', withoutSuffix: '香川' }, en: 'Kagawa' },
  Ehime: { ja: { withSuffix: '愛媛県', withoutSuffix: '愛媛' }, en: 'Ehime' },
  Kochi: { ja: { withSuffix: '高知県', withoutSuffix: '高知' }, en: 'Kochi' },
  Fukuoka: { ja: { withSuffix: '福岡県', withoutSuffix: '福岡' }, en: 'Fukuoka' },
  Saga: { ja: { withSuffix: '佐賀県', withoutSuffix: '佐賀' }, en: 'Saga' },
  Nagasaki: { ja: { withSuffix: '長崎県', withoutSuffix: '長崎' }, en: 'Nagasaki' },
  Kumamoto: { ja: { withSuffix: '熊本県', withoutSuffix: '熊本' }, en: 'Kumamoto' },
  Oita: { ja: { withSuffix: '大分県', withoutSuffix: '大分' }, en: 'Oita' },
  Miyazaki: { ja: { withSuffix: '宮崎県', withoutSuffix: '宮崎' }, en: 'Miyazaki' },
  Kagoshima: { ja: { withSuffix: '鹿児島県', withoutSuffix: '鹿児島' }, en: 'Kagoshima' },
  Okinawa: { ja: { withSuffix: '沖縄県', withoutSuffix: '沖縄' }, en: 'Okinawa' },
  Other: { ja: { withSuffix: 'その他', withoutSuffix: 'その他' }, en: 'Other' },
};

export const convertPrefecture = (
  prefecture: string,
  locale: string = 'ja',
  options: { includeSuffix?: boolean } = {},
): string | null => {
  const { includeSuffix = false } = options;

  const result = prefectureMap[prefecture];
  if (!result) return null;

  if (locale === 'ja') {
    return includeSuffix ? result.ja.withSuffix : result.ja.withoutSuffix;
  } else if (locale === 'en') {
    return result.en;
  }

  return null;
};
